import React, { FC, useId } from 'react';
import { HeadingBlock } from '@design-system/heading-block';
import useJoiValidation from '@root/hooks/useJoiValidation';
import { Keyboard, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { ProductsSliderBubblesProps } from './models';
import { productsSliderBubblesSchema } from './ProductsSliderBubbles.schema';
import SlideScene from './SlideScene';

import './ProductsSliderBubbles.scss';

import 'swiper/css';

const SymptomsSliderBubbles: FC<ProductsSliderBubblesProps> = ({ title, items }) => {
  const uid = useId();

  const { data } = useJoiValidation(productsSliderBubblesSchema, 'ProductsSliderBubblesSchema', {
    title,
    items,
  });

  return (
    <section className="products-slider-bubbles">
      {data.title ? (
        <HeadingBlock
          className="products-slider-bubbles__heading"
          headline={data.title}
          headlineTag="h2"
          headlineSize="m"
        />
      ) : null}
      <Swiper
        modules={[Pagination, Keyboard]}
        keyboard={{
          enabled: true,
          onlyInViewport: true,
        }}
        className="products-slider-bubbles__swiper"
        spaceBetween={24}
        slidesPerView="auto"
        centeredSlides
        loop
        grabCursor
        speed={800}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          320: { spaceBetween: 12, slidesPerView: 1, centeredSlides: true },
          480: { spaceBetween: 16, slidesPerView: 1 },
          768: { spaceBetween: 32, slidesPerView: 1 },
          1024: { spaceBetween: 22, slidesPerView: 1.6 },
        }}
      >
        {data.items.map((item) => (
          <SwiperSlide
            tabIndex={0}
            key={`slide-${uid}-${item.productLink || item.title}`}
            className="products-slider-bubbles__slide"
          >
            <SlideScene {...item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default SymptomsSliderBubbles;
